// Context object + types + hook for PublishContext, split out of the .tsx so the
// component file only exports the PublishProvider component
// (react-refresh/only-export-components).

import { createContext, useContext } from 'react';

// Top-level sub-tabs of the unified YouTube page. "Publish to YouTube" was folded
// into the YouTube media-tab of "generate" (RULE #-2: one SEO+publish surface).
export type PublishTab = 'download' | 'generate';

// Inside "generate": which destination the user is preparing assets for. Both
// generate LLM-written copy + model-aware images; only the destination differs.
export type MediaTab = 'instagram' | 'youtube';

export interface PublishContextValue {
  /** Active top-level sub-tab. */
  tab: PublishTab;
  setTab: (tab: PublishTab) => void;
  /** Active destination inside the "generate" tab (Instagram vs YouTube). */
  mediaTab: MediaTab;
  setMediaTab: (mediaTab: MediaTab) => void;
}

export const PublishContext = createContext<PublishContextValue | null>(null);

export function usePublishContext(): PublishContextValue {
  const ctx = useContext(PublishContext);
  if (!ctx) {
    throw new Error('usePublishContext must be used inside <PublishProvider>');
  }
  return ctx;
}
